module.exports = __webpack_public_path__ + "img/banner_left.4d5e7788.png";